/**
 * Update date: 2025-10-20
 * Screen 2046.H
 */
import LoadPanel from 'app/components/LoadPanel';
import { NotFoundPage } from 'app/components/NotFoundPage';
import useAxios from 'axios-hooks';
import ArrayStore from 'devextreme/data/array_store';
import useDictionary from 'hooks/useDictionary';
import useLocalStorage from 'hooks/useLocalStorage';
import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';

const List = React.lazy(() => import('./List'));
const ViewDetail = React.lazy(() => import('./ViewDetail'));

/**
 * create context
 */
const ModuleContext = createContext({});
ModuleContext.displayName = 'M2046_H_Context';
export const useModuleContext = () => {
  return useContext(ModuleContext);
};

function M2046_H() {
  const dataGridRef: any = useRef(null);
  const [dataLocal, setDataLocal] = useLocalStorage('2046.h_dataList', {});
  const { t }: any = useDictionary({ programId: '2046.H' });
  const [params, setParams] = useState({
    fromDate: new Date(),
    toDate: new Date(),
    dataList: {
      store: [],
      zone: [],
    },
    zone: '',
    store: '',
  });
  const [modeView, setModeView] = useState({ type: 'list' });
  const [listData, setListData] = useState<any>([]);

  const [{ data, loading }, refetchData] = useAxios(
    {
      url: '/warehouse/m2046_h',
      method: 'POST',
      data: { ...params },
    },
    { manual: true, useCache: false, autoCancel: true },
  );

  const store: any = new ArrayStore({
    data: listData,
    key: 'returnDueId',
  });

  /**
   * fetch data
   */
  useEffect(() => {
    if (!dataLocal) return;
    setParams(prev => ({
      ...prev,
      dataList: {
        ...prev.dataList,
        zone: dataLocal?.zone || [],
      },
    }));
  }, [dataLocal]);

  useEffect(() => {
    if (data?.data) {
      dataGridRef?.current?.instance?.clearSelection();
      setTimeout(() => {
        const dataMapping = (data?.data || []).map(o => {
          o.returnedStatusNm = !o?.isReturned ? t('Return') : t('Fixed');
          return o;
        });
        setListData(dataMapping);
      }, 300);
    }
  }, [data]);

  const value: any = {
    t,
    store,
    params,
    setParams,
    refetchData,
    modeView,
    setModeView,
    setDataLocal,
  };

  /**
   * render content
   *
   * @return {*}
   */
  const renderContent = () => {
    switch (modeView?.type) {
      case 'list':
        return <List ref={dataGridRef} />;
      case 'view':
        return <ViewDetail />;
      default:
        return <NotFoundPage />;
    }
  };

  return (
    <ModuleContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        <LoadPanel visible={loading} />
        {renderContent()}
      </React.Suspense>
    </ModuleContext.Provider>
  );
}

export default M2046_H;
